import { Dispatch } from 'redux';
import * as AssignmentApi from 'api/assignment';
import { requestInFlight, requestSuccess, requestError } from '../../actions';
import { AssignmentAttemptActionType } from './types';
import { formatFullDate } from 'util/date-util';

export const getAssignmentAttempt = (assignmentId: number, studentId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch(requestInFlight());

    try {
      const { data: assignmentAttempt } = await AssignmentApi.getAssignmentAttempt(
        assignmentId,
        studentId
      );

      return dispatch(
        requestSuccess(
          { assignmentAttempt },
          { requestActionType: AssignmentAttemptActionType.GET_ASSIGNMENT_ATTEMPT_REQUEST_SUCCESS }
        )
      );
    } catch (err) {
      dispatch(requestError(err));
    }
  };
};

const createMessage = (assignmentId: number, studentId: number, message: any) => async (
  dispatch: Dispatch
) => {
  dispatch(requestInFlight());
  try {
    const { data: newMessage } = await AssignmentApi.createMessage(
      assignmentId,
      studentId,
      message
    );

    return dispatch(
      requestSuccess(
        { assignmentId, studentId, message: newMessage },
        { type: AssignmentAttemptActionType.CREATE_MESSAGE_REQUEST_SUCCESS }
      )
    );
  } catch (err) {
    dispatch(requestError(err));
  }
};

const createAudioMessage = (assignmentId: number, studentId: number, message: any) => async (
  dispatch: Dispatch
) => {
  dispatch(requestInFlight());
  try {
    const { attemptId, file } = message;
    const newMessage = await AssignmentApi.createAudioMessage(
      assignmentId,
      studentId,
      file,
      attemptId
    );

    return dispatch(
      requestSuccess(
        { assignmentId, studentId, message: newMessage?.data },
        { type: AssignmentAttemptActionType.CREATE_MESSAGE_REQUEST_SUCCESS }
      )
    );
  } catch (err) {
    dispatch(requestError(err));
  }
};

const markMessagesAsRead = (
  assignmentId: number,
  studentId: number,
  messageIds: number[]
) => async (dispatch: Dispatch) => {
  dispatch(requestInFlight());
  try {
    await AssignmentApi.updateMessages(
      assignmentId,
      studentId,
      { id: messageIds },
      { dateOpened: formatFullDate(new Date()) }
    );

    return dispatch(
      requestSuccess({}, { type: AssignmentAttemptActionType.READ_MESSAGES_REQUEST_SUCCESS })
    );
  } catch (err) {
    dispatch(requestError(err));
  }
};

export { createMessage, createAudioMessage, markMessagesAsRead };
